var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ListItemText as EDSListItemText } from '@hedtech/react-design-system/core/es/List';
const ListItemText = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (React.createElement(EDSListItemText, Object.assign({}, rest), children));
};
export default ListItemText;
